import { FieldErrorMessage } from '@ui-components/Other/FieldErrorMessage';
import { getFieldErrorId } from '../../helpers/fieldAccessibility';
import { FieldWithMeta, useTanstackFieldError } from './useTanstackFieldAria';

type Props = {
  field: FieldWithMeta;
};

export const TanstackFieldError = ({ field }: Props) => {
  const { errorMessage, shouldShow } = useTanstackFieldError(field);

  if (!shouldShow || !errorMessage) {
    return null;
  }

  return <FieldErrorMessage id={getFieldErrorId(field.name)} errorMessage={errorMessage} />;
};
